module.exports = __webpack_public_path__ + "media/code.0146ab54.mp4";